module.exports = __webpack_public_path__ + "static/img/1_2.8f2b272.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/supplychain/1_2.png
// module id = za8M
// module chunks = 44